'use strict'
import { default as Component } from '../component.js'

class DropdownInputNumber extends Component
{
	init()
	{
		this.input = this.element.querySelector('input')
		this.lastValue = this.input.value
		this.dropdown = this.element.querySelector('.dropdown')
		this.toggle = this.element.querySelector('[data-toggle]')

		if (this.element.attributes['ui-ready'] == true)
			return

		this.element.attributes['ui-ready'] = true
		this.element.addEventListener('click', this.onClick.bind(this))
		this.input.onkeydown = e => this.filterKeys(e)
		this.input.onchange = () => this.resetDisplay()
		this.input.onblur = () => this.resetDisplay()
		this.input.onfocus = () =>
		{
			if (this.input.value && !this.input.validity.valid)
				this.input.reportValidity()
		}
		this.input.oninput = () =>
		{
			if (this.input.validity.customError)
				this.input.setCustomValidity('')
			if (!this.input.value || this.input.checkValidity())
				this.input.classList.remove(App.cssClass.invalid)
			else if (this.input.value && !this.input.validity.valid)
				this.input.reportValidity()
		}
		this.input.oninvalid = () =>
		{
			if (!this.input.validity.customError && this.input.pattern && this.input.title)
				this.input.setCustomValidity(this.input.title)
			this.input.classList.add(App.cssClass.invalid)
		}

		this.toggleDisplay()
	}

	resetDisplay()
	{
		if (!this.input.value)
			this.input.value = this.lastValue
		this.toggleDisplay()
	}

	toggleDisplay()
	{
		let selected = this.element.querySelector('li>a[data-value="' + this.input.value + '"]')
		if (this.input.validity.valid && selected )
		{
			this.toggle.childNodes[0].nodeValue = selected.innerText + ' '

			if (this.dropdown.style.display != '')
			{
				this.dropdown.style.display = ''
				this.input.style.display = 'none'
				this.input.blur()
			}

			if (!selected.classList.contains('selected'))
			{
				this.element.querySelectorAll('a.selected').forEach(el => el.classList.remove('selected'))
				selected.classList.add('selected')
			}
		}
		else if (this.input.style.display != '')
		{
			this.dropdown.style.display = 'none'
			this.input.placeholder = this.lastValue
			this.input.style.display = ''
			this.input.focus()
		}
	}

	filterKeys(e)
	{
		if (isNaN(e.key) && ['Enter', 'Escape', 'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) == -1)
			e.preventDefault()

		if (e.key == 'Enter' && !this.input.value)
			this.resetDisplay()
	}

	onClick(e)
	{
		if (!e.target.matches('a'))
			return

		e.preventDefault()

		if (e.target.dataset.value == this.input.value)
			return

		if (e.target.dataset.value && e.target.dataset.value != this.lastValue)
			this.lastValue = this.input.value

		this.input.value = e.target.dataset.value || ''

		if (this.input.value && this.input.value != this.lastValue)
			this.input.dispatchEvent(new Event('change', { bubbles: true }))
		else
			this.toggleDisplay()
	}
}

export default DropdownInputNumber
